import { useDispatch } from "react-redux";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData";
import { useEffect, useState } from "react";
import { ticketUpdateStatusSuccess, ticketConfirmPoc } from "../../redux/ticketUpdateSlice/ticketUpdateSlice";
import { maskNumber } from "../../utils/helper";
import { ShowAlert } from "../../utils/showAlert";

export const useSelectPoc=()=>{
    const dispatch = useDispatch();
    //eslint-disable-next-line
    const { getTicketUpdateData, getBenList, getTicketData } = UseGetStoreData();
    const [emContacts, setEmContacts] = useState<any[]>([]);
    const [selectedPoc, setSelectedPoc] = useState(null);
    const [openPocForm,setOpenPocForm]=useState(false);
    const [showSavePoc, setShowSavePoc] = useState(false);
    const [isPocSaved, setIsPocSaved] = useState(false);

    const handlePocForm=()=>{
      setSelectedPoc(null);
      setShowSavePoc(!openPocForm);
      setIsPocSaved(false);
      setOpenPocForm(!openPocForm);
    }


  const handleSelectPoc = (event: any) => {
    const pocDet = event.target.value;
    setSelectedPoc(pocDet);
    const getPocDetails = pocDet.split(",");
    createPocPayload(getPocDetails[0], getPocDetails[2]);
    openPocForm&&setOpenPocForm(!openPocForm);
    setShowSavePoc(true);
  };
  const createPocPayload = (fullName: string, mobile: string) => {
    const payload = {
      poc: { fullName, mobile },
    };
    dispatch(ticketUpdateStatusSuccess(payload));
  };

  const handleSavePoc = () => {
    const poc = getTicketUpdateData?.poc;
    if (!poc?.fullName || !poc?.mobile) {
      ShowAlert("warning", "Please select or enter POC details");
      return;
    }
    dispatch(ticketConfirmPoc(poc));
    setShowSavePoc(false);
    setIsPocSaved(true);
  };

  useEffect(() => {
    const patient = getTicketUpdateData?.patient;
    const callerID = getTicketData?.callerID;
    if (patient) {
      const patientOption = patient?.fullName && patient?.mobile
        ? [{ value: `${patient.fullName},patient,${patient.mobile}`, label: `${patient.fullName} (Patient)`, subLabel: maskNumber(patient.mobile) }]
        : [];

      const emContactData = (patient?.emergencyContacts || [])
        .map((ben: any, index: number) => ({
          value: ben?.fullName + "," + index + "," + ben?.mobile,
          label: ben?.fullName,
          subLabel: maskNumber(ben?.mobile),
        }))
        .filter((el: any) => el.value && el.label);

      const knownNumbers = [
        patient?.mobile,
        ...(patient?.emergencyContacts || []).map((c: any) => c?.mobile),
      ].filter(Boolean);

      const callerOption =
        callerID && !knownNumbers.includes(callerID)
          ? [{ value: `Call From Number,caller,${callerID}`, label: "Call From Number", subLabel: maskNumber(callerID) }]
          : [];

      setEmContacts([...callerOption, ...emContactData, ...patientOption]);
    }
  }, [getTicketUpdateData, getTicketData]);
  return{
    emContacts,
    selectedPoc,
    handleSelectPoc,
    openPocForm,
    handlePocForm,
    showSavePoc,
    setShowSavePoc,
    handleSavePoc,
    isPocSaved,
  }
}